// Regex that checks if value has one or more words, separated by spaces, and not allowing symbols
const NAME_REGEX =
  /^\s*[a-zA-Z\u00C0-\u1FFF\u2C00-\uD7FF.\-,']+(\s+[a-zA-Z\u00C0-\u1FFF\u2C00-\uD7FF.\-,']+)*\s*$/

const isNameValid = (value: string): boolean => NAME_REGEX.test(value)

export const validateName = (value: string) => isNameValid(value)
